import { gatewayPhone } from "../../../../../gateways/gatewayPhone";

export type TranscriptionStatus = "none" | "processing" | "completed" | "failed";

export type TranscriptionSentence = {
    speaker: number;
    text: string;
    startTime?: number;
    endTime?: number;
};

export type TranscriptionRecord = {
    uid?: string;
    status: TranscriptionStatus;
    provider?: string;
    transcriptSid?: string;
    text?: string | null;
    sentences?: TranscriptionSentence[];
    languageCode?: string | null;
    durationSeconds?: number | null;
    error?: string | null;
    requestedAt?: string | null;
    completedAt?: string | null;
};

export const startTranscription = async (uid: string): Promise<TranscriptionRecord> => {
    const response = await gatewayPhone.post<TranscriptionRecord>(`/transcriptions/${uid}`);

    return response.data;
};

export const getTranscription = async (uid: string): Promise<TranscriptionRecord> => {
    const response = await gatewayPhone.get<TranscriptionRecord>(`/transcriptions/${uid}`);

    return response.data;
};
